import React, { useState, useEffect } from 'react';
import { Container, Header, MessageList, MessageItem, InputContainer, Input, Button } from './Chat.styles';

// Mock Asana tasks (simulated API response)
const mockAsanaTasks = [
    { id: "task_001", name: "Hi Joseph, could you please check on the refrigerator repair for NHA653-1702?", status: "Pending confirmation" },
    { id: "task_002", name: "Hi Joseph, please confirm that the March payment has been received.", status: "Pending confirmation" },
    { id: "task_003", name: "Hi Joseph, please schedule an inspection for the HVAC system.", status: "Pending confirmation" }
];

const Chat = ({ thread = {}, messages = [] }) => {
    const [chatMessages, setChatMessages] = useState(messages || []);
    const [inputMessage, setInputMessage] = useState("");
    const [asanaTasks, setAsanaTasks] = useState([]);

    // Load all pending tasks on component mount
    useEffect(() => {
        setTimeout(() => {
            setAsanaTasks(mockAsanaTasks); // Load all pending tasks
        }, 1000); // Simulating API delay
    }, []);

    // Send chat message
    const handleSendMessage = () => {
        if (!inputMessage.trim()) return;

        const newMessage = {
            id: Date.now(),
            message: inputMessage,
            created: new Date().toISOString(),
            guest_name: "You",
        };

        setChatMessages([...chatMessages, newMessage]);
        setInputMessage("");

        // Auto-reply bot logic
        handleAutoReply(inputMessage);
    };

    // AI Chatbot auto-reply logic
    const handleAutoReply = (message) => {
        setTimeout(() => {
            const lowerCaseMessage = message.toLowerCase();
            let botMessage;

            if (lowerCaseMessage.includes("hello") || lowerCaseMessage.includes("hi")) {
                botMessage = "Hello! How can I help you today?";
            } else if (lowerCaseMessage.includes("price")) {
                botMessage = "Our prices start from $100 per night. Would you like more details?";
            } else if (lowerCaseMessage.includes("availability")) {
                botMessage = "Please provide your desired dates, and I'll check the availability for you.";
            } else if (lowerCaseMessage.includes("book")) {
                botMessage = "Your booking is confirmed! Let us know if you need any assistance.";
            } else {
                const responses = [
                    "Thank you for your message! We'll get back to you shortly.",
                    "Can you provide more details about your question?",
                    "I'm here to assist you. What do you need help with?",
                ];
                botMessage = responses[Math.floor(Math.random() * responses.length)];
            }

            const botReply = {
                id: Date.now(),
                message: botMessage,
                created: new Date().toISOString(),
                guest_name: "Bot",
            };
            setChatMessages((prev) => [...prev, botReply]);
        }, 1000);
    };

    // Handle user response to a specific Asana task
    const handleUserResponse = (taskId, response) => {
        const updatedTasks = asanaTasks.map((task) =>
            task.id === taskId ? { ...task, status: response === "Approval" ? "Approved" : "Rejected" } : task
        );
        setAsanaTasks(updatedTasks);

        // Add response to chat messages
        setChatMessages([...chatMessages, { id: Date.now(), guest_name: "You", message: `Responded to Asana Task (${taskId}): ${response}` }]);

        console.log(`Updated response "${response}" for Asana task ${taskId}`);
    };

    return (
        <Container style={{ display: "flex", flexDirection: "row", gap: "20px", padding: "20px" }}>
            {/* Left Section - Chat with Guest */}
            <div style={{ flex: 1, border: "1px solid #ddd", padding: "20px", borderRadius: "8px", backgroundColor: "#f9f9f9" }}>
                <Header>Chat with {thread?.guest_id || "Guest"}</Header>

                {/* Chat messages section */}
                <MessageList>
                    {chatMessages.map((msg) => (
                        <MessageItem key={msg.id}>
                            <div>
                                <strong>{msg.guest_name}</strong>
                                <p>{msg.message}</p>
                                <small>{new Date(msg.created).toLocaleString()}</small>
                            </div>
                        </MessageItem>
                    ))}
                </MessageList>

                {/* Chat input box */}
                <InputContainer>
                    <Input
                        type="text"
                        value={inputMessage}
                        onChange={(e) => setInputMessage(e.target.value)}
                        placeholder="Type a message..."
                    />
                    <Button onClick={handleSendMessage}>Send</Button>
                </InputContainer>
            </div>

            {/* Right Section - Asana Pending Tasks */}
            <div style={{ flex: 1, border: "1px solid #61CBC9", padding: "20px", borderRadius: "8px", backgroundColor: "#fff" }}>
                <h2 style={{ fontSize: "24px", color: "#61CBC9", marginBottom: "16px" }}>Asana Pending Confirmation Tasks</h2>

                {asanaTasks.map((task) => (
                    <div key={task.id} style={{ borderBottom: "1px solid #ddd", padding: "10px 0" }}>
                        <p style={{ marginBottom: "8px", lineHeight: "24px" }}>{task.name}</p>
                        <p style={{ marginBottom: "16px" }}><strong>Status:</strong> <span style={{ fontWeight: "500", color: task.status.includes("✅") ? "green" : "red" }}>{task.status}</span></p>
                        {task.status === "Pending confirmation" && (
                            <div>
                                <button onClick={() => handleUserResponse(task.id, "Approval")} style={{ marginRight: "10px", padding: "5px 10px", border: "1px solid #61CBC9", borderRadius: "8px", backgroundColor: "#61CBC9", color: "#fff" }}>Approval</button>
                                <button onClick={() => handleUserResponse(task.id, "Reject")} style={{ padding: "5px 10px", border: "1px solid #61CBC9", borderRadius: "8px", backgroundColor: "#61CBC9", color: "#fff" }}>Reject</button>
                            </div>
                        )}
                    </div>
                ))}
            </div>
        </Container>
    );
};

// Test chat messages
const testMessages = [
    { id: 1, guest_name: "John Doe", message: "Hi, I have a question about my booking." },
    { id: 2, guest_name: "Support", message: "Sure! How can we assist you?" }
];

// Render Chat page
export const ChatPage = () => <Chat thread={{ id: 5678, guest_id: 12345 }} messages={testMessages} />;

export default Chat;
